var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page interactive"},[_c('div',{staticClass:"container"},[_c('gallery',{attrs:{"routeTo":"interactive","items":_vm.items,"gap":"40px"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }